import { assign, clone } from 'lodash';
import { LocalStoreOptions } from 'services';
import * as KEYS from 'constants/keys';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
  data: {},
  meta: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: null,
  error: null,
  notFound: null,
};

const defaultOptions = {
  blog: false,
  tweets: false,
  messages: false,
  statistics: false,
  systemNotices: true,
  videoTutorials: true,
};

const state = assign({}, initState);

const getters = {
  DashboardSettings: state => state,
};

const actions = {
  GetDashboardSettings({ commit }) {
    commit(types.FETCH_DASHBOARD_SETTINGS_START);
    try {
      const options = clone(defaultOptions);
      LocalStoreOptions.get(KEYS.PAGE_HOME_DASHBOARD, options);

      commit(types.RECEIVE_DASHBOARD_SETTINGS, { options });
    } catch (saveError) {
      commit(types.FETCH_DASHBOARD_SETTINGS_ERROR, { saveError });
    }
  },
  SetDashboardSettings({ commit }, { options }) {
    commit(types.SET_DASHBOARD_SETTINGS_START);
    try {
      LocalStoreOptions.set(KEYS.PAGE_HOME_DASHBOARD, options);
      commit(types.SET_DASHBOARD_SETTINGS_SUCCESSFUL, { options });
    } catch (error) {
      commit(types.SET_DASHBOARD_SETTINGS_ERROR, { error });
    }
  },
  ClearDashboardSettings({ commit }) {
    commit(types.CLEAR_DASHBOARD_SETTINGS_STORE);
  },
};

const mutations = {
  [types.FETCH_DASHBOARD_SETTINGS_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_DASHBOARD_SETTINGS_ERROR](state, { error }) {
    assign(state, neutralState, { error });
  },
  [types.RECEIVE_DASHBOARD_SETTINGS](state, { options }) {
    assign(state, neutralState, { ready: true, data: options });
  },

  [types.CLEAR_DASHBOARD_SETTINGS_STORE](state) {
    assign(state, initState);
  },

  [types.SET_DASHBOARD_SETTINGS_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.SET_DASHBOARD_SETTINGS_SUCCESSFUL](state, { options }) {
    assign(state, neutralState, {
      saved: true,
      data: options,
    });
  },
  [types.SET_DASHBOARD_SETTINGS_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/dashboard/entities/dashboard-settings.js